import { QuotesTable } from "components";

const Quotes = () => {

    return (
        <QuotesTable />
    );

}
export default Quotes;